import React from "react";
import { buildCountriesArray } from "../../../../helpers/OrdersFunctionsGlobal";
import InputPhone from "../../../common/InputPhone";
import { LabelTextStyle } from "../../../common/StyledComponents";
import TextInputModal from "../../../common/TextInputModal";
import useFetch from "../../../../hooks/useFetch";
import SelectInput from "../../../common/SelectInput";

function ServiceForms_2({ client, onChangeHandler, errors }) {
  const { value: countriesData } = useFetch("/api/v1/countries");
  const countries = buildCountriesArray(countriesData?.data);
  return (
    <div>
      <LabelTextStyle>Client information</LabelTextStyle>
      <div className="row">
        <div className="col-3">
          <TextInputModal
            text="First name"
            required={true}
            name="client_name"
            value={client.client_name}
            onChange={(e) => onChangeHandler(e, "client")}
            warning={errors.client_name}
          />
        </div>
        <div className="col-3">
          <TextInputModal
            text="Last name"
            required={true}
            name="client_lastname"
            value={client.client_lastname}
            onChange={(e) => onChangeHandler(e, "client")}
            warning={errors.client_lastname}
          />
        </div>
        <div className="col-3">
          <InputPhone
            number_start={client.client_country_id}
            disabled={!client.client_country_id}
            type="text"
            text="Phone"
            required={true}
            name="client_phone"
            placeholder="6XXXXXXX"
            value={client.client_phone}
            onChange={(e) => onChangeHandler(e, "client")}
            warning={errors.client_phone}
          />
        </div>
        <div className="col-3">
          <TextInputModal
            text="Email"
            required={true}
            name="client_mail"
            value={client.client_mail}
            onChange={(e) => onChangeHandler(e, "client")}
            warning={errors.client_mail}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-3">
          <SelectInput
            required={true}
            label="Country"
            value={client.client_country_id || undefined}
            onChange={(value) =>
              onChangeHandler(
                { target: { value, name: "client_country_id" } },
                "client"
              )
            }
            options={countries}
            error={errors.client_country_id}
          />
        </div>
        <div className="col-3">
          <TextInputModal
            text="City"
            required={true}
            name="client_city"
            value={client.client_city}
            onChange={(e) => onChangeHandler(e, "client")}
            warning={errors.client_city}
          />
        </div>
        <div className="col-3">
          <TextInputModal
            text="Street"
            required={true}
            name="client_street"
            value={client.client_street}
            onChange={(e) => onChangeHandler(e, "client")}
            warning={errors.client_street}
          />
        </div>
        <div className="col-3">
          <TextInputModal
            text="Postal code"
            type="number"
            required={true}
            name="client_postal_code"
            value={client.client_postal_code}
            onChange={(e) => onChangeHandler(e, "client")}
            warning={errors.client_postal_code}
          />
        </div>
      </div>
    </div>
  );
}

export default ServiceForms_2;
